<template>
  <div
    :id="containerId"
    class="custom-option-popover__container"
  >
    <b-popover
      :target="target"
      placement="bottomleft"
      triggers="focus"
      :container="containerId"
    >
      <div class="ap-popover">
        <ul>
          <li>
            <b-button
              id="customOptionPopoverRename"
              @click="$emit('click-rename', option)"
            >
              {{ $t('global.rename') }}
            </b-button>
          </li>
          <li>
            <b-button
              id="customOptionPopoverUpdate"
              @click="$emit('click-update', option)"
            >
              {{ $t('global.updateFilter') }}
            </b-button>
          </li>
          <li>
            <b-button
              id="customOptionPopoverRemove"
              @click="$emit('click-remove', option)"
            >
              <i
                class="fal fa-trash mr-2"
                aria-hidden="true"
              />{{ $t('global.delete') }}
            </b-button>
          </li>
        </ul>
      </div>
    </b-popover>
  </div>
</template>

<script>

export default {
    name: 'CustomOptionPopover',
    props: {
        target: { type: String, required: true },
        option: { type: Object, required: true },
        defaultOption: { type: Object, default: null },
        store: { type: Object }
    },
    computed: {
        label() {
            return this.option.label
        },
        isDefaultOption() {
            if (this.store) {
                return this.store.state.config.defaultOptionId === this.option.id
            }
            return this.defaultOption?.id === this.option.id
        },
        containerId() {
            return `container-${this.target}`
        }
    },
    methods: {
        setDefaultOption() {
            if (this.store) {
                if (this.isDefaultOption) {
                    this.store.setDefaultOption(null)
                } else {
                    this.store.setDefaultOption(this.option)
                }
                this.store.saveConfig()
            }
        }
    }
}

</script>

<style lang="scss" scoped>

.popbtn:hover{
background:vt-color(light-primary);
}

#customOptionPopoverRemove{
  color: #fc6274 !important;
}

.list-group-item-action{
  color: #707070 !important;
}

.custom-option-popover__container {
    ::v-deep .popover-body {
    padding: 0;
    .list-group-item-action {
      cursor: pointer;
    }
  }
}

</style>
